
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-fill",attrs:{"d":"M8 38h13v3H8zM18 32a2 2 0 1 1-4 0 2 2 0 0 1 4 0M9 15h7v6H9zM18 15h8v2h-8zM18 18h10v1H18zM18 20h4v1h-4zM23 20h5v1h-5zM31 15h9v15h-9zM31 39h9v-7h-9z","fill":"#D0EFEC"}}),_c('path',{staticClass:"i-Rectangle 23",attrs:{"stroke":"#234652","d":"M3.5 7.5h42v32h-42z"}}),_c('path',{staticClass:"i-Line 24",attrs:{"stroke":"#234652","d":"M4 11.5h41"}}),_c('path',{staticClass:"i-Rectangle 24",attrs:{"stroke":"#234652","d":"M9.5 23.5h18v4h-18z"}}),_c('path',{staticClass:"i-Ellipse 14",attrs:{"stroke":"#234652","d":"M12.5 32a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"}}),_c('path',{staticClass:"i-Ellipse 18",attrs:{"stroke":"#234652","d":"M16.5 32a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"}}),_c('path',{staticClass:"i-Ellipse 16",attrs:{"stroke":"#234652","d":"M22.5 32a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"}}),_c('path',{staticClass:"i-Ellipse 17",attrs:{"stroke":"#234652","d":"M27.5 32a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"}}),_c('path',{staticClass:"i-Line 25",attrs:{"stroke":"#234652","d":"M23.5 24v3"}}),_c('path',{staticClass:"i-Line 26",attrs:{"stroke":"#234652","d":"M25 25.5h1"}}),_c('path',{staticClass:"i-Rectangle 26",attrs:{"stroke":"#234652","d":"M9.5 36.5h13v3h-13z"}}),_c('path',{staticClass:"i-Line 27",attrs:{"stroke":"#234652","d":"M43 9.5h1"}}),_c('path',{staticClass:"i-Line 28",attrs:{"stroke":"#234652","d":"M41 9.5h1"}}),_c('path',{staticClass:"i-Line 29",attrs:{"stroke":"#234652","d":"M39 9.5h1"}})])
          )
        }
      }
    